import Widget from './widget';
import endpoints from '../constants/endpoints';
import Localization from '../../../../../common/react/utilities/localization';
import { request } from '../../shared/utilities';
import axios from 'axios';

export default class SignupFormWidget extends Widget {
	constructor (data) {
		super(data);

		this.monitoredInputs = [];


		var template = 'ftl/pageWidget/editor';
		var localizedStateMapping = "";
        axios({
            method: 'POST',
            url: '/apps/localization',
            data: {template}
        }).then(response => {
            localizedStateMapping = response.data;
            this.state = {
                localization: new Localization(localizedStateMapping)
            };

            if (this.firstNameLabel) {
				this.firstNameLabel.innerHTML = this.state.localization.substitute(this.firstNameLabel.innerHTML);
			}

            if (this.lastNameLabel) {
				this.lastNameLabel.innerHTML = this.state.localization.substitute(this.lastNameLabel.innerHTML);
			}

            if (this.emailLabel) {
				this.emailLabel.innerHTML = this.state.localization.substitute(this.emailLabel.innerHTML);
			}

            if (this.phoneLabel) {
				this.phoneLabel.innerHTML = this.state.localization.substitute(this.phoneLabel.innerHTML);
			}

            this.submitButton.innerHTML = this.state.localization.substitute(this.submitButton.innerHTML);
        });

	}


	get notification () {
		return this.node.querySelector('.notification');
	}

	get firstNameField () {
		return this.node.querySelector('.first-name.field');
	}

	get firstNameInput () {
		return this.node.querySelector('.first-name input');
	}

	get firstNameLabel () {
		return this.node.querySelector('.first-name_label');
	}

	get lastNameField () {
		return this.node.querySelector('.last-name.field');
	}

	get lastNameInput () {
		return this.node.querySelector('.last-name input');
	}

	get lastNameLabel () {
		return this.node.querySelector('.last-name_label');
	}

	get emailField () {
		return this.node.querySelector('.email.field');
	}

	get emailInput () {
		return this.node.querySelector('.email input');
	}

	get emailLabel () {
		return this.node.querySelector('.email_label');
	}

	get phoneField () {
		return this.node.querySelector('.phone.field');
	}

	get phoneInput () {
		return this.node.querySelector('.phone input');
	}

	get phoneLabel () {
		return this.node.querySelector('.phone_label');
	}

	get submitButton () {
		return this.node.querySelector('.submit.button');
	}

	get successNotice () {
		return this.node.querySelector('.success-notice');
	}

	clearForm () {
		this.hideNotifications();

		let { fields, requiredFields } = this.configuration;

		const transformedRequiredFields = this.type === 'SIGNUP_FORM' && Array.isArray(requiredFields) ? requiredFields.reduce((acc, field) => {
			acc[field] = true;
			return acc;
		}, {}) : requiredFields;

		if (fields.firstName) {
			this.firstNameInput.value = '';
			this.firstNameInput.classList.remove('valid');
			this.updateLabel(
				this.firstNameLabel,
				this.state.localization.substitute(`First Name${transformedRequiredFields.firstName ? ' (required)' : ''}`)
			);
		}

		if (fields.lastName) {
			this.lastNameInput.value = '';
			this.lastNameInput.classList.remove('valid');
			this.updateLabel(
				this.lastNameLabel,
				this.state.localization.substitute(`Last Name${transformedRequiredFields.lastName ? ' (required)' : ''}`)
			);
		}

		if (fields.email) {
			this.emailInput.value = '';
			this.emailInput.classList.remove('valid');
			this.updateLabel(
				this.emailLabel,
				this.state.localization.substitute(`Email${transformedRequiredFields.email ? ' (required)' : ''}`)
			);
		}

		if (fields.phone) {
			this.phoneInput.value = '';
			this.phoneInput.classList.remove('valid');
			this.updateLabel(
				this.phoneLabel,
				this.state.localization.substitute(`Phone${transformedRequiredFields.phone ? ' (required)' : ''}`)
			);
		}
	}

	clearValidations () {
		this.hideNotifications();
	}

	hideNotification (input) {
		input.classList.remove('notification');
	}

	hideNotifications () {
		if (this.emailInput) {
			this.emailInput.classList.remove('notification');
		}
		if (this.phoneInput) {
			this.phoneInput.classList.remove('notification');
		}
	}

	highlightField (className, field) {
		field.classList.add(className);
	}

	initialize () {
		let { fields } = this.configuration;

		this.hideSuccessNotice();

		if (fields.firstName) {
			this.listenForInput(this.firstNameInput);
		}

		if (fields.lastName) {
			this.listenForInput(this.lastNameInput);
		}

		if (fields.email) {
			this.listenForInput(this.emailInput);
		}

		if (fields.phone) {
			this.listenForInput(this.phoneInput);
		}

		this.startInputMonitor();

		this.submitButton.addEventListener('click', evt => this.submit());

		super.initialize();
	}

	listenForInput (input) {
		this.monitoredInputs.push({
			isPopulated: false,
			node: input
		});
	}

	notify (message) {
		this.notification.innerHTML = message;
		this.notification.classList.remove('hidden');
	}

	updateLabel (label, message) {
		label.innerHTML = message;
	}

	hideSuccessNotice () {
		this.successNotice.classList.add('hidden');
	}

	showSuccessNotice () {
		this.successNotice.classList.remove('hidden');
	}

	startInputMonitor () {
		this.monitoredInputs.forEach(input => {
			input.node.addEventListener('keyup', evt => {
				input.isPopulated = evt.target.value !== '';

				if (input.isPopulated) {
					input.node.classList.add('valid');
					this.hideNotification(input.node);
					return;
				} else {
					input.node.classList.remove('valid');
				}

			});
		});
	}

	submit () {
		this.clearValidations();
		let { fields, requiredFields } = this.configuration;

		const transformedRequiredFields = this.type === 'SIGNUP_FORM' && Array.isArray(requiredFields) ? requiredFields.reduce((acc, field) => {
			acc[field] = true;
			return acc;
		}, {}) : requiredFields;

		let data = {
			websiteId: this.configuration.websiteId,
			groupId: this.configuration.groupId,
			groupName: encodeURIComponent(this.configuration.groupName),
			ownerId: this.configuration.ownerId
		};

		let attentionRequired = false;

		if (fields.firstName) {
			data.firstName = this.firstNameInput.value;

			if (transformedRequiredFields.firstName && data.firstName === '') {
				attentionRequired = true;
				this.highlightField('notification', this.firstNameInput);
				this.updateLabel(
					this.firstNameLabel,
					this.state.localization.substitute('First name is required')
				);
			}
		}

		if (fields.lastName) {
			data.lastName = this.lastNameInput.value;

			if (transformedRequiredFields.lastName && data.lastName === '') {
				attentionRequired = true;
				this.highlightField('notification', this.lastNameInput);
				this.updateLabel(
					this.lastNameLabel,
					this.state.localization.substitute('Last name is required')
				);
			}
		}

		if (fields.email) {
			data.email = this.emailInput.value;

			if (transformedRequiredFields.email && data.email === '') {
				attentionRequired = true;
				this.highlightField('notification', this.emailInput);
				this.updateLabel(
					this.emailLabel,
					this.state.localization.substitute('Email is required')
				);
			}
		}

		if (fields.phone) {
			data.phone = this.phoneInput.value;

			if (transformedRequiredFields.phone && data.phone === '') {
				attentionRequired = true;
				this.highlightField('notification', this.phoneInput);
				this.updateLabel(
					this.phoneLabel,
					this.state.localization.substitute('Phone is required')
				);
			}
		}

		if (attentionRequired) {
			return;
		}

		request({...endpoints.SUBMIT_SIGNUP_FORM, data}).then(response => {
			this.showSuccessNotice();
			this.clearForm();

			setTimeout(() => {
				this.minimize();
				this.hideSuccessNotice();
			}, 1618);
		}).catch(error => {
			console.warn(error.response.data);

			switch (error.response.status) {
				case 409:
					this.highlightField('notification', this.emailInput);
					this.updateLabel(
						this.emailLabel,
						this.state.localization.substitute('Looks like we already have your info.')
					);
					break;

				case 412:
					this.highlightField('notification', this.emailInput);
					this.updateLabel(
						this.emailLabel,
						this.state.localization.substitute('Enter a valid email address.')
					);
					break;

				default:
					alert('An error occurred processing your request. Please try again later.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/public/classes/signup-form-widget.js